import {Card, CardActionArea, Typography, css, styled} from '@mui/material';
import Icon from 'presentation/icons';
import {ShortcutStyleProps} from './types';

const StyledCardActionArea = styled(CardActionArea)<ShortcutStyleProps>`
	min-width: 104px;
	height: 72px;
	border-radius: 8px;

	${({$layoutVariant}) =>
		$layoutVariant === 'portal' &&
		css`
			height: 120px;
			border-radius: 20px;
		`}

	${({theme, $layoutVariant}) =>
		$layoutVariant === 'portal' &&
		theme.breakpoints.down('sm') &&
		css`
			height: 112px;
		`}

		
	${({theme, $layoutVariant}) => $layoutVariant !== 'portal' && theme.breakpoints.down('sm')} {
		height: 52px;
	}
`;

const StyledCard = styled(Card)<ShortcutStyleProps>`
	display: flex;
	height: 100%;
	align-items: center;
	padding: 16px;
	gap: 12px;

	${({theme}) => theme.breakpoints.down('sm')} {
		gap: 8px;
		padding: 8px 12px;
	}

	${({$layoutVariant, theme}) =>
		$layoutVariant === 'portal' &&
		css`
			flex-direction: column;
			align-items: flex-start;
			justify-content: space-between;
			padding: 18px;
			gap: 16px;
			border-radius: 20px;
			background-color: ${theme.palette.grey[100]};
			border: 0;

			${theme.breakpoints.down('sm')} {
				padding: 16px;
			}
		`}

	${({$hasEmphasis, theme}) =>
		$hasEmphasis &&
		css`
			background-color: ${theme.palette.other?.planColor || theme.palette.primary.main};
		`}
`;

const StyledTypography = styled(Typography)<ShortcutStyleProps>`
	font-size: ${({$customFontSize}) => $customFontSize ?? '13px'};
	text-align: left;
	font-weight: 600;
	line-height: 1.5;
	letter-spacing: 0.46px;

	white-space: ${({$breakTitle}) => ($breakTitle ? 'pre-line' : 'normal')};

	${({theme}) => theme.breakpoints.down('sm')} {
		font-size: ${({$customFontSize}) => $customFontSize ?? '12px'};
	}

	${({$layoutVariant}) =>
		$layoutVariant === 'portal' &&
		css`
			font-size: 1rem !important;
			line-height: 1.35;
		`}

	${({$hasEmphasis, theme}) =>
		$hasEmphasis &&
		css`
			color: ${theme.palette.common.white};
		`}
`;

const StyledIcon = styled(Icon)<ShortcutStyleProps>`
	flex-shrink: 0;

	${({theme}) => theme.breakpoints.down('sm')} {
		width: 17px;
		height: 17px;
	}

	${({$layoutVariant}) =>
		$layoutVariant === 'portal' &&
		css`
			width: 20px !important;
			height: 20px !important;
		`}

	color: ${({$hasEmphasis, $layoutVariant, theme}) => {
		if ($hasEmphasis) return theme.palette.common.white;
		if ($layoutVariant === 'portal') return theme.palette.text.primary;
		return theme.palette.primary.main;
	}};
`;

export {StyledCardActionArea, StyledCard, StyledTypography, StyledIcon};
